/* eslint-disable @typescript-eslint/no-explicit-any */
import apiEndpoints from '@src/lib/apiEndpoints';

import apiRequest from './api';

export const getUsers = (params: any) => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.USERS}`,
    config: { params },
  });
};

export const createUsers = (params: any) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.CREATE_USERS}`,
    data: params,
  });
};

export const updateUsers = (params: any) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.UPDATE_USERS}`,
    data: params,
  });
};

export const deleteUsers = (id: string) => {
  return apiRequest({
    method: 'DELETE',
    url: `${apiEndpoints.USERS_URL}${id}`,
  });
};

export const createRoomDisplayAccount = (roomId: string) => {
  return apiRequest({
    method: 'POST',
    url: apiEndpoints.ROOM_DISPLAY_ACCOUNTS,
    data: { roomId },
  });
};
